export const findSegmentByContentObjectGuid = (segments: any, contetObjectGuid: string) => {
    return segments.find((segment: any) => {
        if (
            segment.Categories !== undefined &&
            segment.Categories !== null &&
            Object.keys(segment.Categories).length > 0
        ) {
            // Categories is now Dictionary<string, ContentGroupingModel>
            // ContentGroupingModel has NonDrillSmartContent and DrillSmartContent
            return Object.values(segment.Categories).some((contentGrouping: any) => {
                // Check NonDrillSmartContent
                if (contentGrouping.NonDrillSmartContent?.Content) {
                    const found = contentGrouping.NonDrillSmartContent.Content.find(
                        (co: any) => co.ContentObjectGuid === contetObjectGuid
                    );
                    if (found) return true;
                }
                // Check DrillSmartContent
                if (contentGrouping.DrillSmartContent && Array.isArray(contentGrouping.DrillSmartContent)) {
                    const found = contentGrouping.DrillSmartContent.some((drillSmartGroup: any) => {
                        if (drillSmartGroup.Content && Array.isArray(drillSmartGroup.Content)) {
                            return drillSmartGroup.Content.find(
                                (co: any) => co.ContentObjectGuid === contetObjectGuid
                            );
                        }
                        return false;
                    });
                    if (found) return true;
                }
                return false;
            });
        } else {
            return undefined
        }
    })
}